/**
 *
 * NVError
 *
 */

import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { ErrorHandler } from '../../Services'
import { SelectorUtils } from '../../Utils'
import message from '../message'

const { selector } = SelectorUtils

const DELAY_IN_MS = 500

class NVError extends React.Component {
  prevTick = Date.now()

  hasElapsed = () => Date.now() - this.prevTick > DELAY_IN_MS

  componentDidUpdate (prevProps) {
    const { clear, error } = this.props
    if (this.hasElapsed() && !_.isEmpty(error) && error !== prevProps.error) {
      this.prevTick = Date.now()
      message.error(this.props.message)
      clear()
    }
  }

  render () {
    return null
  }
}

const mapStateToProps = createStructuredSelector({
  error: selector('error')()
})

function mapDispatchToProps (dispatch) {
  return {
    clear: () => dispatch(ErrorHandler.creators.clear())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect)(NVError)
